/**
 * Variant content updater (price, buttons, etc.) for product pages.
 * Only runs when a product form with variant picker and product JSON is present.
 * Call from inline variant picker scripts after changing the selected variant id.
 */
(function () {
  'use strict';

  function getProductData(form) {
    if (typeof theme === 'undefined' || !theme.OptionManager || !theme.OptionManager.getProductData) {
      return null;
    }
    return theme.OptionManager.getProductData(form);
  }

  function getProductDataFromDom(productId) {
    var el = document.getElementById('ccProductJson-' + productId);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /** Variant prices from Liquid (same source as initial price block) to avoid rounded product JSON. */
  function getVariantPricesFromLiquid(productId) {
    var el = document.getElementById('marlowVariantPrices-' + productId);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /**
   * Updates price, buttons, and related UI for the selected variant.
   * Safe to call from variant picker scripts. No-op if not on a product page or data missing.
   * @param {number} variantId - Selected variant id
   */
  function marlowUpdateVariantContent(variantId) {
    if (!variantId) return;

    var $ = window.jQuery || window.$;
    if (!$) return;

    var $idInput = $('#selectedVariantId, #singleVariantId').filter(function () {
      return $(this).closest('.product-container').length > 0;
    }).first();
    if ($idInput.length === 0) {
      $idInput = $('.product-container input[name="id"]').first();
    }
    if ($idInput.length === 0) return;

    var $form = $idInput.closest('form');
    if ($form.length === 0) return;

    var productId = $form.data('product-id');
    if (!productId) return;

    var productData = getProductData($form);
    if (!productData && productId) {
      productData = getProductDataFromDom(productId);
      if (productData && typeof theme !== 'undefined') {
        theme.productData = theme.productData || {};
        theme.productData[productId] = productData;
      }
    }
    if (!productData || !productData.variants) return;

    var variant = null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (Number(productData.variants[i].id) === Number(variantId)) {
        variant = productData.variants[i];
        break;
      }
    }
    if (!variant) return;

    var variantPrices = getVariantPricesFromLiquid(productId);
    if (variantPrices && variantPrices[variantId]) {
      var p = variantPrices[variantId];
      variant = Object.assign({}, variant, {
        price: p.price,
        compare_at_price: p.compare_at_price != null ? p.compare_at_price : variant.compare_at_price
      });
    }

    var $container = $form.closest('.product-container');
    if ($container.length === 0) return;

    if (typeof theme !== 'undefined' && theme.OptionManager) {
      var om = theme.OptionManager;
      if (om.updatePrice) om.updatePrice(variant, $container);
      if (om.updateButtons) om.updateButtons(variant, $container);
      if (om.updateSku) om.updateSku(variant, $container);
      if (om.updateBarcode) om.updateBarcode(variant, $container);
      if (om.updateWeight) om.updateWeight(variant, $container);
      if (om.updateInventoryNotice) om.updateInventoryNotice(variant, $container);
      if (om.updateBackorder) om.updateBackorder(variant, $container);
      if (om.updateContainerStatusClasses) om.updateContainerStatusClasses(variant, $container);
      if (om.updateInventoryLimit) om.updateInventoryLimit(variant, $container);
      if (variant && variant.featured_media) {
        $container.find('.product-gallery').trigger('variantImageSelected', variant);
      }
      $(window).trigger('cc-variant-updated', { variant: variant, product: productData });
      return;
    }

    var $priceArea = $container.find('.product-price');
    if ($priceArea.length && variant) {
      $priceArea.removeClass('on-sale');
      var priceCents = Number(variant.price);
      var compareAtCents = variant.compare_at_price != null ? Number(variant.compare_at_price) : 0;
      var showDiscount = compareAtCents > priceCents;
      var priceHtml = '';
      if (typeof theme !== 'undefined' && theme.formatMoney) {
        priceHtml = '<span class="current-price theme-money">' + theme.formatMoney(variant.price) + '</span>';
        if (showDiscount) {
          priceHtml += ' <span class="was-price theme-money">' + theme.formatMoney(variant.compare_at_price) + '</span>';
          $priceArea.addClass('on-sale');
        }
      } else {
        var formatCents = function (cents) {
          var c = Math.floor(Number(cents));
          var d = Math.floor(c / 100);
          var p = c % 100;
          return d + '.' + String(p < 0 ? p + 100 : p).padStart(2, '0');
        };
        priceHtml = '<span class="current-price theme-money">' + formatCents(variant.price) + '</span>';
        if (showDiscount) {
          priceHtml += ' <span class="was-price theme-money">' + formatCents(variant.compare_at_price) + '</span>';
          $priceArea.addClass('on-sale');
        }
      }
      $priceArea.html(priceHtml);
    }
  }

  window.marlowUpdateVariantContent = marlowUpdateVariantContent;
})();
